export class AuthApi {
    constructor(client) {
        this.client = client;
    }

    async login(credentials) {
        return this.client.post('/auth/login', credentials);
    }

    async ssoExchange(code) {
        return this.client.post('/auth/sso/exchange', { code });
    }

    async listPublicSsoProviders() {
        return this.client.get('/auth/public/sso-providers');
    }

    async logout(refreshToken = null) {
        return this.client.post('/auth/logout', { refreshToken });
    }

    async getCurrentUser() {
        return this.client.get('/auth/me');
    }

    async getPartyAssignmentFlags() {
        return this.client.get('/auth/me/party-assignment-flags');
    }

    async refreshToken(refreshToken) {
        return this.client.post('/auth/refresh', { refreshToken });
    }

    async register(data) {
        return this.client.post('/auth/register', data);
    }

    async forgotPassword(data) {
        const body = typeof data === 'string' ? { email: data } : data;
        return this.client.post('/auth/forgot-password', body);
    }

    async forgotPasswordVerify(data) {
        return this.client.post('/auth/forgot-password/verify', data);
    }

    async resetPassword(data) {
        return this.client.post('/auth/reset-password', data);
    }

    async activateAccount(data) {
        return this.client.post('/auth/activate-account', data);
    }

    async getTenantAuthOptions(tenantId) {
        return this.client.get(`/auth/public/tenant/${tenantId}/auth-options`);
    }

    async getVerificationChannels(tenantId = null) {
        return this.client.get('/auth/public/verification-channels', {
            params: tenantId ? { tenantId } : undefined,
        });
    }

    async verifyMfa(data) {
        return this.client.post('/auth/mfa/verify', data);
    }

    async resendMfa(data) {
        return this.client.post('/auth/mfa/resend', data);
    }

    async requestPasswordChangeOtp(data = {}) {
        return this.client.post('/auth/me/password/request-otp', data);
    }

    async confirmPasswordChange(data) {
        return this.client.post('/auth/me/password/confirm', data);
    }

    async changeExpiredPassword(data) {
        return this.client.post('/auth/password-expired/change', data);
    }

    async requestMfaToggleOtp(data) {
        return this.client.post('/auth/me/mfa/request-otp', data);
    }

    async confirmMfaToggle(data) {
        return this.client.post('/auth/me/mfa/confirm', data);
    }

    async patchMySecurity(data) {
        return this.client.patch('/auth/me/security', data);
    }

    async evaluateTenantSwitch(data) {
        return this.client.post('/auth/tenant-switch/evaluate', data);
    }

    async verifyTenantSwitch(data) {
        return this.client.post('/auth/tenant-switch/verify', data);
    }
}
